export default "__VITE_ASSET__6O0ZvL2n__"